import { Skeleton } from "../ui/skeleton";

export function DomainUpsertLoadingList({ count = 4 }: { count?: number }) {
  return (
    <div className="grid gap-3 mt-3">
      {Array.from({ length: count })
        .fill(0)
        .map((_, i) => (
          <Skeleton className="h-5 w-10" key={i} />
        ))}
    </div>
  );
}

export function DomainUpsertLoadingForm({ count = 4 }: { count?: number }) {
  return (
    <div className="grid gap-3 mt-3">
      {Array.from({ length: count })
        .fill(0)
        .map((_, i) => (
          <Skeleton className="h-14 full" key={i} />
        ))}
    </div>
  );
}
